if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.data = JSON.parse(this.querySelector('[data-bundle-offer-data]').textContent);
        this.priceContainer = document.getElementById(`price-${this.sectionId}`);
        this.singlePriceHTML = this.priceContainer ? this.priceContainer.innerHTML : '';

        this.addEventListener('change', (event) => {
          if (event.target.classList.contains('bundle-offer__radio')) this.apply();
        });

        // The variant picker writes the single variant id into the form synchronously,
        // so by the time the change bubbles to the document we can swap in the bundle id.
        this.onPickerChange = (event) => {
          if (event.target.closest(`[data-section="${this.sectionId}"]`) && event.target.closest('variant-radios, variant-selects')) {
            this.apply();
          }
        };
        document.addEventListener('change', this.onPickerChange);

        // renderProductInfo re-renders the price block after fetching; keep our override on top of it.
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            if (!this.priceContainer) return;
            this.singlePriceHTML = this.priceContainer.innerHTML;
            this.apply();
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onPickerChange);
        if (this.unsubscribe) this.unsubscribe();
      }

      getSingleVariantId() {
        const picker = document.querySelector(
          `variant-radios[data-section="${this.sectionId}"], variant-selects[data-section="${this.sectionId}"]`
        );
        if (picker && picker.currentVariant) return String(picker.currentVariant.id);
        return String(this.data.initialVariant);
      }

      apply() {
        const checked = this.querySelector('.bundle-offer__radio:checked');
        const singleId = this.getSingleVariantId();
        const single = this.data.single[singleId];

        this.updateCards(singleId);

        if (!checked || checked.value === 'single') {
          this.setVariantId(singleId);
          if (this.priceContainer) this.priceContainer.innerHTML = this.singlePriceHTML;
          if (single) this.setButton(single.available);
          return;
        }

        const bundle = this.data.bundles[Number(checked.value)];
        const match = bundle && bundle.variants[singleId];

        if (!match) {
          this.setButton(false, window.variantStrings.unavailable);
          return;
        }

        this.setVariantId(match.id);
        if (this.priceContainer) {
          this.priceContainer.innerHTML = `
            <div class="price price--large${match.compareHtml ? ' price--on-sale' : ''}">
              <div class="price__container">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${match.priceHtml}</span>
                </div>
                ${
                  match.compareHtml
                    ? `<div class="price__sale">
                        <s class="price-item price-item--regular">${match.compareHtml}</s>
                        <span class="price-item price-item--sale price-item--last">${match.priceHtml}</span>
                      </div>`
                    : ''
                }
              </div>
            </div>`;
        }
        this.setButton(match.available);
      }

      updateCards(singleId) {
        const options = this.querySelectorAll('.bundle-offer__option');
        const single = this.data.single[singleId];
        if (single && options[0]) options[0].querySelector('[data-bundle-price]').innerHTML = single.priceHtml;

        this.data.bundles.forEach((bundle, index) => {
          const option = options[index + 1];
          if (!option) return;
          const match = bundle.variants[singleId];
          option.classList.toggle('bundle-offer__option--unavailable', !match || !match.available);
          option.querySelector('[data-bundle-price]').innerHTML = match ? match.priceHtml : window.variantStrings.unavailable;
          const unit = option.querySelector('[data-bundle-unit]');
          if (unit) unit.innerHTML = match ? `${match.unitHtml} ${this.data.eachLabel}` : '';
          const compare = option.querySelector('[data-bundle-compare]');
          if (compare) compare.innerHTML = match ? match.compareHtml : '';
          const badge = option.querySelector('[data-bundle-badge]');
          if (badge) {
            badge.hidden = !match || !match.savePercent;
            if (match) badge.textContent = this.data.badge.replace('[percent]', match.savePercent);
          }
        });
      }

      setVariantId(id) {
        document
          .querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}`)
          .forEach((form) => {
            const input = form.querySelector('input[name="id"]');
            if (input) input.value = id;
          });
      }

      setButton(available, text) {
        const form = document.getElementById(`product-form-${this.sectionId}`);
        if (!form) return;
        const button = form.querySelector('[name="add"]');
        const label = form.querySelector('[name="add"] > span');
        if (!button) return;
        if (available) {
          button.removeAttribute('disabled');
          if (label) label.textContent = window.variantStrings.addToCart;
        } else {
          button.setAttribute('disabled', 'disabled');
          if (label) label.textContent = text || window.variantStrings.soldOut;
        }
      }
    }
  );
}
